export function isIos(): boolean {
  return (
    !!/(Mac|iPhone|iPod|iPad)/i.exec(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}
